export default {
    id: "",
    label: "",
    buttons: [],
    enableExport: true,
    enableFiltering: true,
    enableOptions: true,
    enableContext: true,
    endpoint: '',
    exportOptions: {},
    favorite: null,
    filter: {},
    filtersComponent: undefined,
    linkedtype: "",
    name: "",
    params: {},
    prefilter: {},
    savedSearchesUrl: "",
    switchDisplay: false,
    url: "",
    useFavorites: true,
    group: '',
    favoritesName: '',
    mapname: '',
    aggregations: [],
}